import { Button, TextField, TextareaAutosize } from "@mui/material"
import ButtonComponent from "../../../components/ButtonComponent"
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { object, string } from "yup";
import RHFTextFieldMaterial from "../../../components/controls/RHFTextFieldMaterial";
import RHFTextareaMaterial from "../../../components/controls/RHFTextareaMaterial";
import Supabase from "../../../backend/client";
import { useNavigate, useParams } from "react-router-dom";
import { useUser } from "../../../context/UserContext";
import { ALGO_STATUS } from "../../../shared/constant";
import { backtest } from "../../../services/Stock";
import { errorToaster, successToaster } from "../../../util/toaster";
import { getuuid } from "../../../util/functions";
import { useEffect } from "react";

export const SavePopup = ({
    showPopup, dndRequest, algoAction, handleClose, setAlgoResult,
    algoResult,
    backtestStats,
    setBacktestStats,
    loading,
    setLoading,
    setSelectedStockLst,
    selectedStockList,
    algoDetails
}) => {
    const navigate = useNavigate();
    const params = useParams();
    const user = useUser();
    const userDetails = user?.user;
    const schema = object({
        title: string().required().label("Algo. Title"),
        desc: string().required().label("Algo. Description"),
        price: string().required().label("Algo. Price")
    });

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
    } = useForm({
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        if(params?.id){
            setValue('title', algoDetails?.title)
            setValue('price', algoDetails?.algo_price)
            setValue('desc', algoDetails?.description)
        }
    },[])

    useEffect(() => {
        console.log('selectedStockListselectedStockList1', selectedStockList);
    }, [selectedStockList])

    const onSubmit = async (data) => {
        
        if(!backtestStats && !params?.id) {
            errorToaster("Run backtest first");
            return
        }
        setLoading(true)
        const buyReq = dndRequest?.filter((item) => item?.type === "BUY");
        const sellReq = dndRequest?.filter((item) => item?.type === "SELL");
        const backtestRes = await backtest(dndRequest, selectedStockList);
        
        setBacktestStats(backtestRes?.backtestResult);
        setAlgoResult(backtestRes?.result);

        let createObj;

        if(!params?.id) {
            createObj = {
                user_id: userDetails?.id,
                username: userDetails?.user_metadata?.name,
                left_logic: JSON.stringify(buyReq),
                right_logic: JSON.stringify(sellReq),
                algo_price: data?.price,
                algo_custom_id: getuuid("ALGO"),
                used_counter: 0,
                title: data?.title,
                description: data?.desc,
                status: algoAction === "Save" ? ALGO_STATUS?.Draft : ALGO_STATUS?.Publish,
                backtest_details: backtestStats !== null ? JSON.stringify({...backtestRes?.backtestResult, stocks: selectedStockList}) : null,
            };
        }
        else {
            createObj = {
                user_id: userDetails?.id,
                username: userDetails?.user_metadata?.name,
                left_logic: JSON.stringify(buyReq),
                right_logic: JSON.stringify(sellReq),
                algo_price: data?.price,
                used_counter: 0,
                title: data?.title,
                description: data?.desc,
                status: algoAction === "Save" ? ALGO_STATUS?.Draft : ALGO_STATUS?.Publish,
                backtest_details: JSON.stringify({...backtestRes?.backtestResult, stocks: selectedStockList})
            };
        }
        

          let result;
          if(params?.id) {
            result = await Supabase.from("algos").update(createObj).eq('id', params?.id).select();
          }
          else {
            result = await Supabase.from("algos").insert([createObj]).select();
          }
          if (result?.error) {
            errorToaster(result?.error?.message);
            setLoading(false)
            navigate("/dashboard");
            return;
          }
          successToaster("Algo created successfully.");
          setLoading(false)
          navigate("/dashboard");
          return;
        
    }

   

    return (
        <div className={`flex flex-col fixed z-[102] top-[0px] left-[0px] right-[0px] bottom-[0px] bg-[#00000050]`}>
            <div className={`absolute max-w-[700px] w-[80%] min-h-[400px] rounded-[20px] bg-white top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]`}>
                <div className="flex flex-col w-full h-full rounded-[20px]">
                    <div className="h-[60px] w-full bg-[#001639] rounded-t-[20px] text-white text-[30px] items-center flex px-[20px] jusify-between flex-row">
                        <h3 className="flex flex-1">{algoAction} Algo.</h3>
                        <Button className="!border !border-solid !border-white !text-white !text-[15px] !min-w-[22px] !w-[22px] !h-[22px] !rounded-full !flex !items-center !justify-center !pt-[8px] !pl-[8px]" onClick={handleClose}>X</Button>
                    </div>
                </div>
                <div className="flex flex-1 flex-col p-[20px] gap-5">
                    <div className="flex flex-row gap-5">
                        <RHFTextFieldMaterial
                            name="title"
                            placeholder='Algo. Title'
                            fullWidth
                            control={control}
                            errorObj={errors}
                            isControlled={true}
                            className={'flex flex-1'}
                        />
                        <RHFTextFieldMaterial
                            name="price"
                            placeholder='Algo. Price'
                            fullWidth
                            control={control}
                            errorObj={errors}
                            type="number"
                            isControlled={true}
                        />
                    </div>
                    <RHFTextareaMaterial
                        name="desc"
                        placeholder='Algo. Description'
                        fullWidth
                        className="!h-[150px] !border !border-solid !p-[10px] !border-[#c4c4c4] !rounded-[4px]"
                        control={control}
                        errorObj={errors}
                        isControlled={true}
                    />
                </div>
                <div className="flex flex-row justify-end items-center px-[20px] h-[55px]  gap-[10px] items-center">
                    <Button className="!border !border-solid !border-[#1976d2] !bg-[#1976d2] !text-white !min-w-[90px] disabled:!bg-[#9dc9ec] !border-[#9dc9ec]" onClick={handleSubmit(onSubmit)} disabled={loading}>{loading ? "Please wait..." : algoAction}</Button>
                    <Button className="!border !border-solid !border-[#1976d2] !w-[90px]" onClick={handleClose}>Cancel</Button>
                </div>
            </div>
        </div>
    )
}